import React from "react";
import { Breadcrumb, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Guaranties = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main">
        <Container className="py-5 px-1">
          <Breadcrumb>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/")}
              >
                Home
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small className="BreadCrumbs_style">Guarantees</small>
            </Breadcrumb.Item>
          </Breadcrumb>
          <Row>
            <Col md={3} xl={3}>
              <div className="d-grid gap-2 pb-3 Account_card_div">
                <div className="Account_btns Faq_Cards p-4 align_center">
                  <h6 className="pt-2 ">
                    <b>Have Questions?</b>
                  </h6>
                  <p className="text_muted">
                    Call (833) 465 0300 or contact us via chat.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={9} xl={9} className="shipping_spacing px-5">
              <Card className=" Shipping_Card box_shadow">
                <Card.Header className="blue_bg Account_Card_Header ">
                  <Container>
                    <Row>
                      <Col className="Header_Text ps-4 ">
                        <b>Genuine Software - Guaranteed</b>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                <Card.Body className="px-4">
                  <div className="Shipping_Card_text">
                    <p className="text_muted">
                      We know shopping for genuine software online can be a
                      difficult and sometimes frustrating task to complete.
                      Especially with the number of vendors saturating the
                      market with non-legitimate software and/or selling
                      licensing keys that were never meant to become available
                      to the general public, usually at prices that are simply
                      to good to be true.
                    </p>
                    <br />
                    <p className="text_muted">
                      We pride ourselves on taking great care and caution when
                      ordering our inventory to avoid the above scenarios. By
                      only purchasing only from authorized Microsoft partners,
                      we are able to guarantee that every single one of products
                      will include legitimate software and license keys that are
                      directly from the manufacturer with the sole purpose of
                      resale.
                    </p>
                  </div>
                </Card.Body>
              </Card>

              <Card className="Shipping_Card box_shadow mt-5">
                <Card.Header className="blue_bg Account_Card_Header ">
                  <Container>
                    <Row>
                      <Col className="Header_Text ps-4 ">
                        <b>Customer Satisfaction - Guaranteed </b>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                <Card.Body className="px-4 pt-4">
                  <div className="Shipping_Card_text">
                    <p className="text_muted">
                      Shop with confidence knowing that we offer a 90-day
                      hassle-free refund policy for all purchases made at
                      Liberty Programs. If you're not completelty satisfied with
                      your purchase, please reach out to our sales team for a
                      full refund. Terms and conditions may apply.
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Guaranties;
